import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { historyActions } from 'src/ducks/actions'
import { getOrderHistoryByJob } from 'src/ducks/history/selectors'
import { getJob } from 'src/ducks/selectors'
import { ROWS_PER_PAGE_SIMPLE } from 'src/helpers'
import headers from './headers'

const Dispatch = ({ id }: { id?: string }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const orderHistory = useSelector(getOrderHistoryByJob)
  const job = useSelector(getJob())

  const [page, setPage] = useState(0)
  const [size, setSize] = useState(50)
  const [historyRecords, setHistoryRecords] = useState(orderHistory)

  useEffect(() => {
    updatePage()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size, orderHistory])

  const updatePage = () => {
    const start = page * size
    const end = start + size > orderHistory.length ? orderHistory.length : start + size

    setHistoryRecords(orderHistory.slice(start, end))
  }

  const fetchOrderHistory = useCallback(() => {
    if (id) {
      dispatch(
        historyActions.fetchOrderHistoryByJob(id, (_succ: boolean) => {
          setLoading(false)
        })
      )
    }
  }, [dispatch, id])

  useEffect(() => {
    fetchOrderHistory()
  }, [fetchOrderHistory, job])

  return (
    <Table
      headers={headers}
      title='DISPATCH HISTORY'
      loading={loading}
      small
      totalItems={orderHistory.length}
      rowsPerPageDefault={50}
      rowsPerPageOptions={ROWS_PER_PAGE_SIMPLE}
      callToApi={(start, limit) => {
        setPage(start)
        setSize(limit)
      }}
      hasTopPagination
      hasPagination={false}
    >
      {historyRecords}
    </Table>
  )
}

export default Dispatch
